import { createFileRoute } from '@tanstack/react-router';

import { client } from '@@api/client';
import { serializeCategoryColumnId } from '@@api/services/placement/columnIds';
import { handleLoaderError } from '@@router/handleLoaderError';

// The category and its page, for the modals that add a section to it or edit one of its sections
export const Route = createFileRoute(
    '/_authenticated/placement/$tenantId/category/$categoryId/sections',
)({
    context: ({ params }) => ({
        categoryQuery: client.tenant.category.get.queryOptions({
            params: { id: Number(params.categoryId) },
        }),
        categoryPageQuery: client.placement.categoryPage.get.queryOptions({
            params: {
                id: serializeCategoryColumnId(Number(params.tenantId), Number(params.categoryId)),
            },
        }),
    }),
    loader: ({ context }) =>
        Promise.all([
            context.queryClient.query({ ...context.categoryQuery, staleTime: 'static' }),
            context.queryClient.query({ ...context.categoryPageQuery, staleTime: 'static' }),
        ]).catch(handleLoaderError),
});
